import PaymentIcon from '@mui/icons-material/Payment';
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import * as React from "react";
import {useEffect, useState} from "react";
import {post} from "../utils/post";
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {storage} from "../utils/localstorage";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import {Paper} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import css from "../css/profile.module.css";
import {signOut} from "firebase/auth";
import {auth} from "../firebase";
import {Courses} from "../components/Courses";
import {TGLogo, VKLogo} from "./Main";
import bridge from '@vkontakte/vk-bridge';


const Account = ({appType, name, id, photo, courses, items}) => {
    const coursesChange = async (courses) => {
        await post({method: "coursesChange", courses}, true);
    }

    const navigate = useNavigate();

    const logOut = async () => {
        await signOut(auth);
        storage("authData", false);
        navigate("/");
    }

    const isGoogle = appType === "gg";

    return (
        <Paper elevation={3} sx={{p: 2}}>
            <ListItem alignItems={"center"}>
                <ListItemAvatar>
                    {photo ? <Avatar alt={name} src={photo}/> : <AccountCircleIcon sx={{fontSize: 45}}/>}
                </ListItemAvatar>
                <ListItemText primary={name}/>
            </ListItem>
            <Courses items={items} courses={courses} onChange={coursesChange}/>

            {isGoogle && <Button variant={"contained"} onClick={logOut}>Выйти</Button>}
        </Paper>
    )
}


const InvoiceList = ({invoices}) => {
    const list = {};

    invoices.forEach(invoice => {
        list[invoice.tariffId] = {
            name: invoice.tariff,
            months: invoice.months + (list[invoice.tariffId] ? list[invoice.tariffId].months : 0)
        }
    })

    return (
        Object.values(list).map(({name, months}) => (
            <small key={name}><br/>+ Подписка на тариф "{name}" на {months} мес.</small>
        ))
    )
}

const Tariff = ({tariffId, name, locked, invoices, expiration}) => {
    const navigate = useNavigate();

    const onClick = async () => {
        const {invoice} = await post({method: "invoiceCreate", renew: true}, true);
        navigate(`/payment/${invoice.id}/`);
    }

    return (
        <Paper elevation={3} sx={{p: 2}}>
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                    <CardGiftcardIcon sx={{fontSize: 45}}/>
                </ListItemAvatar>
                <ListItemText primary={`Тариф ${name}`} secondary={
                    <>
                        <Typography component="span" variant="subtitle1">
                            Функционал {locked ? "ограничен" : "не ограничен"}
                        </Typography>
                        <br/>
                        <Typography component="span" variant={"subtitle2"}>
                            {expiration ? `Действует до ${new Date(expiration).toLocaleDateString("ru")}` : "Срок истек"}
                        </Typography>
                        <InvoiceList invoices={invoices}/>
                    </>
                }/>
            </ListItem>


            <div style={{display: "flex", gap: 16}}>
                {!!tariffId && (
                    <Button id={"renewTariff"} variant={"contained"} onClick={onClick}
                            startIcon={<AutorenewIcon/>}>Продлить</Button>
                )}
                <Button id={"chooseTariff"} onClick={() => navigate("/payment")} variant={"contained"}
                        startIcon={<PaymentIcon/>}>Выбрать тариф</Button>
            </div>
        </Paper>
    )
}
const Contact = ({authData}) => {
    return (
        <Paper elevation={3} sx={{p: 2}}>
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                    <InfoIcon sx={{fontSize: 45}}/>
                </ListItemAvatar>
                <ListItemText primary={`Контакты`} secondary={<Typography component="span" variant="subtitle1">info@mathem.org</Typography>}/>
            </ListItem>

            {authData.appType === "vk" &&
            <div style={{display: "flex", gap: 16}}><Button target={"_blank"} id={"writeToDevelopers"}
                                                            variant={"contained"} startIcon={<VKLogo/>}
                                                            href={"https://vk.com/im?entrypoint=community_page&media=&sel=-230724135"}>Написать
                разработчикам</Button></div>}
            {authData.appType === "tg" &&
            <div style={{display: "flex", gap: 16}}><Button target={"_blank"} id={"writeToDevelopers"}
                                                            variant={"contained"} startIcon={<TGLogo/>}
                                                            href={"https://t.me/+N3icf4e617g3M2Ji"}>Написать
                разработчикам</Button></div>}

            <Button target={"_blank"} href={"https://mathem.org/doc/terms.pdf"}>Пользовательское соглашение</Button>
        </Paper>
    )
}
export const Profile = () => {
    const [profile, setProfile] = useState(null);

    useEffect(() => {
        post({method: "profile"}, true).then(setProfile);
    }, [])

    if (!profile) return;

    const {isTrial, invoices, info: {locked, courses: items}, user: {endTrial, invoice, courses}} = profile;

    const authData = storage("authData");

    return (
        <div className={css.profile}>
            <Typography variant={"h5"} gutterBottom align={"center"}>Профиль</Typography>
            <Account items={items} courses={courses} appType={authData.appType} id={authData.id}
                     name={authData.displayName} photo={authData.photo}/>
            {isTrial && <Tariff name={"Trial"} expiration={endTrial} locked={locked} invoices={invoices}/>}
            {!isTrial && invoice &&
            <Tariff tariffId={invoice.tariffId} name={invoice.tariff} expiration={invoice.expirationDate}
                    locked={locked} invoices={invoices}/>}
            <Contact authData={authData}/>
        </div>
    )
}
